import React from "react";
import LocationsDetails from "./LocationDetailedView";

const Locations = () => {
  return (
    <div className="flex flex-col bg-custom-bg-purple w-full flex-1 h-full min-h-0 max-w-full overflow-hidden">
      <LocationsDetails />
    </div>
  );
};

export default Locations;